<p id="username" *ngIf="userName">
  {{ 'User.Greeting' | translate }} {{ userName }}
</p>
